export enum HttpMethods {
    Get = "GET",
    Post = "POST",
    Put = "PUT",
    Path = "PATCH",
    Delete = "DELETE"
}